import { render, staticRenderFns } from "./TestOmiPay.vue?vue&type=template&id=0d95c414&scoped=true"
import script from "./TestOmiPay.vue?vue&type=script&lang=js"
export * from "./TestOmiPay.vue?vue&type=script&lang=js"
import style0 from "./TestOmiPay.vue?vue&type=style&index=0&id=0d95c414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95c414",
  null
  
)

export default component.exports